module.exports = __webpack_public_path__ + "ida_design_awards_fashion_moodboard_photography_graphic_design_typography.jpg?0346acc4b256dc758960928772886840";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/ida/ida_design_awards_fashion_moodboard_photography_graphic_design_typography.jpg
// module id = 64
// module chunks = 0